export interface LocationItem {
  id: string;
  name: string;
}

export const PROVINCES: LocationItem[] = [
  { id: "RN", name: "Río Negro" }
];

export const CITIES_BY_PROVINCE: Record<string, LocationItem[]> = {
  "RN": [
    { id: "RN-GR", name: "Gral. Roca" },
    { id: "RN-ALL", name: "Allen" },
    { id: "RN-IH", name: "Ing. Huergo" },
    { id: "RN-VR", name: "Regina" },
    { id: "RN-CIP", name: "Cipolletti" }
  ]
};

export const ALL_CITIES = Object.values(CITIES_BY_PROVINCE).flat();

// Funciones de ayuda para obtener el nombre a partir del ID
export const getCityName = (cityId: string) => {
  if (!cityId) return '';
  for (const cities of Object.values(CITIES_BY_PROVINCE)) {
    const city = cities.find(c => c.id === cityId);
    if (city) return city.name;
  }
  return cityId; // fallback por si es un nombre viejo
};

export const getProvinceName = (provinceId: string) => {
  if (!provinceId) return '';
  const prov = PROVINCES.find(p => p.id === provinceId);
  return prov ? prov.name : provinceId;
};
